import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

const NAV = [
  { label: "Services", href: "/#services" },
  { label: "Areas", href: "/areas" },
  { label: "Prices", href: "/prices" },
  { label: "Gains", href: "/#gains" },
  { label: "FAQ", href: "/#faq" },
  { label: "Journal", href: "/blog" },
  { label: "Contact", href: "/book" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.76, 0, 0.24, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="brand-logo">
          <span className="w-2 h-2 bg-volt group-hover:bg-white transition-colors" />
          <span className="font-display text-lg tracking-tight uppercase">
            Mids<span className="text-volt">Tuning</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10 font-mono text-xs uppercase tracking-widest">
          {NAV.map((n, i) => (
            <a
              key={n.href}
              href={n.href}
              className="relative text-white/70 hover:text-white transition-colors"
              data-testid={`nav-${n.label.toLowerCase()}`}
            >
              <span className="text-volt mr-2">{String(i + 1).padStart(2, "0")}</span>
              {n.label}
            </a>
          ))}
        </nav>

        <Link
          to="/book"
          className="hidden md:inline-flex items-center gap-2 bg-volt text-black px-5 py-3 font-mono text-xs uppercase tracking-widest font-semibold hover:bg-white transition-colors duration-300"
          data-testid="header-book-cta"
        >
          Book Remap →
        </Link>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          <div className="w-6 h-[2px] bg-white mb-1.5" />
          <div className="w-6 h-[2px] bg-white" />
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
            className="md:hidden bg-black border-t border-white/10 overflow-hidden"
          >
            <div className="px-6 py-4 flex flex-col font-mono text-sm uppercase tracking-widest">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="text-white/80 py-3.5 border-b border-white/5 active:text-volt"
                  data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                >
                  {n.label}
                </a>
              ))}
              <Link
                to="/book"
                onClick={() => setOpen(false)}
                className="mt-4 mb-2 block text-center bg-volt text-black px-5 py-4 text-xs font-semibold active:bg-white"
                data-testid="mobile-book-cta"
              >
                Book Remap →
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
